import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {AddMessage, AddMessageOnDb, AddTicketMessageOnDb, LoadMessages, MessagesActionTypes, MessagesRequested, TicketMessagesRequested} from './messages.actions';
import {MessageModel} from '../models';
import {MessagesService} from '../services';
import {Store} from '@ngrx/store';
import { AppState } from 'libs/tm-common/src/lib/store/reducers/reducers';


@Injectable({
	providedIn: 'root'
})
export class MessagesEffects {
	private actions$ = inject(Actions);
	private store$ = inject<Store<AppState>>(Store);
	private messagesService = inject(MessagesService);

	messages$ = createEffect(() => this.actions$.pipe(
		ofType<MessagesRequested>(MessagesActionTypes.MessagesRequested),
		withLatestFrom(this.store$),
		mergeMap(([, store]) => this.messagesService.getMessages(store.router.state.params.id)),
		map((messages: MessageModel[]) => new LoadMessages({messages})),
		catchError(err => {
			console.error('error loading messages');
			return throwError( () => new Error(err));
		})
	));


	messagesTicket$ = createEffect(() => this.actions$.pipe(
		ofType<TicketMessagesRequested>(MessagesActionTypes.TicketMessagesRequested),
		mergeMap(( {payload} ) => this.messagesService.getMessagesTicket(payload.ticketId)),
		map((messages: MessageModel[]) => new LoadMessages({messages})),
		catchError(err => {
			console.error('error loading ticket messages');
			return throwError( () => new Error(err));
		})
	));


	addMessageOnDb$ = createEffect(() => this.actions$.pipe(
		ofType<AddMessageOnDb>(MessagesActionTypes.AddMessageOnDb),
		mergeMap(( {payload} ) => this.messagesService.createMessage(payload.message)),
		map((message: MessageModel) => new AddMessage({message})),
		catchError(err => {
			console.error('error while updating message');
			return throwError( () => new Error(err));
		})
	));

	addTicketMessageOnDb$ = createEffect(() => this.actions$.pipe(
		ofType<AddTicketMessageOnDb>(MessagesActionTypes.AddTicketMessageOnDb),
		mergeMap(( {payload} ) => this.messagesService.createTicketMessage(payload.ticketId, payload.message, payload.messageType)),
		map((message: MessageModel) => new AddMessage({message})),
		catchError(err => {
			console.error('error while updating ticket message');
			return throwError( () => new Error(err));
		})
	));
}
